module.exports = __webpack_public_path__ + "static/media/grad6.d4fd102b.jpg";